import React from 'react'
import styles from './Main.module.scss'
import InitialPage from '../../components/initialPage/InitialPage'
import StagesWork from '../../components/StagesWork/StagesWork'
import Services from '../../components/Services/Services'
import Dignities from '../../components/Dignities/Dignities'
import Documents from '../../components/Documents/Documents'
import Questions from '../../components/Questions/Questions'
import Map from '../../components/Map/Map'


const Main = ({isOpen, isPrivacyPolicyOpenOpen, popupOpen, isImageOpen}) => {

    return (
        <section className={styles.main}>
            <InitialPage
                isOpen={isOpen}
            />
            <Services
                isOpen={isOpen}
            />
            <Questions/>
            <Dignities/>
            <StagesWork/>
            <Documents/>
            <Map/>
        </section>
    )
}

export default Main